import Block from 'components/Block'
import Flex from 'components/Flex'
import GymaholicFitnessAppTitle from 'components/GymaholicFitnessAppTitle'
import PageSubTitle from 'components/Page/Page.SubTitle.js'
import PageTitle from 'components/Page/Page.Title.js'
import TextBody from 'components/TextBody'
import TextTitleLight from 'components/TextTitleLight'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import { STYLES_BORDER_RADIUS } from 'modules/styles/constants/index.cjs'
import { Image } from 'components/Image'
import { isMobileScreenViewportSelect } from 'modules/viewport/selectors/index.js'
import { CheckExerciseFormCTA } from '../Cta'

const TEXT_MAX_WIDTH_MOBILE = 420
const TEXT_MAX_WIDTH_DESKTOP = 600

const messages = defineMessages({
  gymaholic: {
    id: 'CheckExerciseFormHero.gymaholic',
    defaultMessage: 'Gymaholic'
  },
  fitnessApp: {
    id: 'CheckExerciseFormHero.fitnessApp',
    defaultMessage: 'App'
  },
  subtitle: {
    id: 'CheckExerciseFormHero.subtitle',
    defaultMessage: 'Perfect Your Form with AI 💪'
  },
  description: {
    id: 'CheckExerciseFormHero.description',
    defaultMessage: 'Record your sets and get instant AI feedback on your exercise form. Prevent injuries, maximize gains, and lift with confidence.'
  }
})

const PHONES_IMAGE_SOURCE = '/app/check-exercise-form/hero.png'

function getProportionalHeight (givenWidth) {
  const originalWidth = 1038
  const originalHeight = 986

  return (givenWidth * originalHeight) / originalWidth
}

export function CheckExerciseFormHero () {
  const intl = useIntl()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const isMobile = useSelector(isMobileScreenViewportSelect)

  let imageWidth
  if (isMobile) {
    imageWidth = 244
  } else if (isSmallScreen) {
    imageWidth = 296
  } else {
    imageWidth = 500
  }
  const imageWidthStr = imageWidth + 'px'
  const imageHeightStr = getProportionalHeight(parseInt(imageWidth, 10)) + 'px'

  return (
    <Block
      style={{
        textAlign: 'center'
      }}
      hasSmallVerticalPadding
    >
      <View
        row={!isSmallScreen}
        centered
        style={{
          textAlign: isSmallScreen ? 'center' : 'left'
        }}
      >
        <Flex
          style={{
            maxWidth: isSmallScreen
              ? TEXT_MAX_WIDTH_MOBILE
              : TEXT_MAX_WIDTH_DESKTOP
          }}
        >
          <View
            as={isSmallScreen ? 'center' : 'flex-start'}
            jc
          >
            <View w={isSmallScreen ? '100%' : 'auto'}>
              <PageTitle>
                <GymaholicFitnessAppTitle />
              </PageTitle>

              <PageSubTitle style={{ marginBottom: 0 }}>
                <TextTitleLight
                  fs={isSmallScreen ? 'small' : 'body'}
                >
                  {formatMessageIntlUtil(intl, messages.subtitle)}
                </TextTitleLight>
              </PageSubTitle>
            </View>

            <TextBody mt>
              {formatMessageIntlUtil(intl, messages.description)}
            </TextBody>

            {
              !isSmallScreen && (
                <CheckExerciseFormCTA />
              )
            }
          </View>
        </Flex>
        <Flex mt={isSmallScreen ? 2 : 0}>
          <Image
            src={PHONES_IMAGE_SOURCE}
            alt='An image of the Gymaholic App showing the check your exercise form feature'
            style={{
              margin: '0 auto',
              width: imageWidthStr,
              height: imageHeightStr,
              borderRadius: STYLES_BORDER_RADIUS.ROUNDED
            }}
          />
        </Flex>

        {
          isSmallScreen && (
            <CheckExerciseFormCTA />
          )
        }
      </View>
    </Block>
  )
}
